<template>
    <div class="container" id="post">
        <div v-if="post">
            <h2 class="titulo">{{ post.titulo }}</h2>
            <div class="contenido html ql-editor" v-html="post.descripcion"></div>

            <div class="fuentes" v-if="post.fuentes">
                <span>FUENTE: </span>
                <span v-for="fuente in post.fuentes">
                    <a :href="fuente.link" target="_blank">{{ fuente.titulo }}</a> 
                </span> 
            </div>
            <button @click="volver" class="btn btn-default">Volver</button>
        </div>

        <div id="disqus_thread"></div>
    </div>
</template>

<script>

import blogService from '../services/blog/blog.service.js'

var serv = new blogService();

export default {
    name: 'post-item',
    data () {
        return {
            post: null,
            id: 0
        }
    },

    methods: {
        buscarPostId: function() {
            var cmp = this;
            serv.getById(this.id, function(p) {
                cmp.post = p;
                setTimeout(function() {
                    window.scrollTo(0,1200);
                }, 100);

                cmp.cargarDisqus();
            });
        },

        cargarDisqus() {
            var cmp = this;
            var disqus_config = function () {
                //this.page.url = PAGE_URL;  // Replace PAGE_URL with your page's canonical URL variable
                this.page.identifier = cmp.id; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
            };

            (function() { // DON'T EDIT BELOW THIS LINE
            var d = document, s = d.createElement('script');
            s.src = '//worldpartsonline.disqus.com/embed.js';
            s.setAttribute('data-timestamp', +new Date());
            (d.head || d.body).appendChild(s);
            })();
        },

        volver: function() {
          this.$router.go(-1)
        }
    },

    created: function () {
        this.id = this.$route.params.id;
        this.buscarPostId();
    },
}

</script>

<style scoped>

  .btn-default {
      background-color:#196C7E;
      color:#fff;
      border-radius: 0px;
      float:right;
  }

  .titulo {
    font-weight: bold;
  }

  .contenido  {
    margin-top: 30px;
  }

  #post {
    margin-top:50px;
  }

  .fuentes {
      margin: 20px 0;
      padding: 10px;
      background: rgba(204, 204, 204, 0.12);
  }

</style>



// WEBPACK FOOTER //
// Post-Item.vue?1076cdfc